import { FormDataModel } from '@/model/FormModel'
import { baseForm } from './baseForm'

export const editFromData: FormDataModel[] = [
  {
    title: '基本信息',
    type: 1, // 常规表单
    labelClass: 'blue',
    labelName: '基',
    formList: baseForm
  }
]
